{
  "/about/dmca": "/dmca",
  "/business": "/pricing#business",
  "/NemoV": "/use-cases/free-thinkers",
  "/FreedomForceNews": "/use-cases/free-thinkers",
  "/amrenaissance": "/use-cases/free-thinkers",
  "/DavisMJAurini": "/use-cases/free-thinkers",
  "/neonrevolt": "/use-cases/free-thinkers",
  "/wesearchr": "/use-cases/free-thinkers",
  "/heheSillyComics": "/use-cases/free-thinkers",
  "/condeloppeux": "/use-cases/free-thinkers",
  "/Philosophy": "/use-cases/free-thinkers",
  "/tv": "/use-cases/free-thinkers",
  "/poseidonlive": "/use-cases/free-thinkers",
  "/Alex_Linder": "/use-cases/free-thinkers",
  "/theduran": "/use-cases/free-thinkers",
  "/AndrewAnglin": "/use-cases/free-thinkers",
  "/characters": "/use-cases/free-thinkers",
  "/about/guidelines": "/use-cases/free-thinkers",
  "/about/android": "/use-cases/free-thinkers",
  "/start/gabby": "/use-cases/free-thinkers",
  "/a": "/use-cases/free-thinkers",
  "/realalexjones": "/use-cases/free-thinkers",
  "/settings/billing": "/settings?page=subscription"
}
